<template>
  <div class="col-12 px-0">
    <NewsletterType
      :draft="draft"
      :newsletter-types="newsletterTypes"
      :initial-value="initialValue"
      @clearedDraft="onClearedDraft"
    />
  </div>
</template>

<script>
import NewsletterType from './Components/NewsletterType'

export default {
  name: 'GenericOverviewStep',

  components: {
    NewsletterType,
  },

  props: {
    draft: {
      type: Object,
      required: true,
    },
    newsletterTypes: {
      type: Array,
      required: true,
    },
  },

  data: () => ({
    initialValue: null,
    error: null,
  }),

  metaInfo () {
    return {
      title: this.draft && this.draft.subject ? this.draft.subject : 'Create Newsletter',
    }
  },

  beforeMount() {
    const {template} = this.$route.query

    if (template === 'tellimer-today-latest-layout') {
      const tellimerToday = this.newsletterTypes.find(t => t.slug === 'tellimer-today')
      this.initialValue = tellimerToday
    }
  },

  methods: {
    onClearedDraft (newDraft) {
      this.$emit('clearedDraft', newDraft)
    },
  },
}
</script>

